import {jwtDecode} from 'jwt-decode';
import {BrowserStorageUtils, StorageKey} from './browser-storage.utils';

export interface JwtClaims {
  [key: string]: any;
}

/**
 * Tries to retrieve and decode a JWT from localStorage or sessionStorage.
 * @param key The storage key to look for (default: 'twpub-accessToken').
 * @returns The decoded claims, or undefined if not found/invalid.
 */
export function getDecodedJwt(key: StorageKey = BrowserStorageUtils.ACCESS_TOKEN_KEY): JwtClaims | undefined {
  const token = getTokenFromStorage(key);
  if (!token) return undefined;
  try {
    return jwtDecode<JwtClaims>(token);
  } catch {
    return undefined;
  }
}

export function getTokenFromStorage(key: StorageKey): string | null {
  return BrowserStorageUtils.getLocalStorage(key) || BrowserStorageUtils.getSessionStorage(key);
}
